<template>
  <div id="dashboard-home">
    <div class="container pt-2">
      <h1>Your Explorations</h1>
      <router-link :to="{ name: 'Dashboard', params: {mode: 'exploration-settings'} }" class="btn btn-outline-primary mt-2"><i class="fal fa-plus-circle"></i> Create Exploration</router-link>

      <div v-if="explorations" v-for="exploration in explorations" class="card mt-4">
        <div class="card-body">
          <h2 class="card-title">{{ exploration.title }}</h2>
          <button @click="editExploration(exploration.id)" class="btn btn-outline-primary"><i class="fal fa-map-marker-alt"></i> Edit</button>
          <button @click="explorationSettings(exploration.id)" class="btn btn-outline-primary"><i class="fal fa-cog"></i> Settings</button>
          <button @click="deleteExploration(exploration.id)" class="btn btn-outline-danger"><i class="fal fa-trash"></i> Delete</button>
          <button
            @click="duplicateExploration(exploration.id)"
            class="btn btn-outline-info"
          >
            <i class="fas fa-copy"></i> Duplicate
          </button>
        </div>
      </div>
      <div v-else>No Explorations yet!</div>
    </div><!-- /.container -->
  </div><!-- /#dashboard-home -->
</template>

<script>
  import { mapState } from 'vuex'
  const fb = require('../firebaseConfig.js')
  import moment from 'moment'

  export default {
    data() {
      return {
        explorations: []
      }
    },
    computed: {
      ...mapState(['userProfile', 'currentUser'])
    },
    created() {
      this.getExplorations()
    },
    methods: {
      explorationSettings(id) {
        this.$router.push({name: 'Dashboard', params:{mode: 'exploration-settings', id: id}})
      },
      editExploration(id) {
        this.$router.push({name: 'Dashboard', params: {mode: 'edit-exploration', id: id}})
      },
      deleteExploration(id) {
        let check = confirm("DANGER!!! Are you sure you want to delete this Exploration? THIS CANNOT BE UNDONE!!");
        if (check == true) {
          fb.explorationsCollection.doc(id).delete().then(doc => {
            this.explorations = []
            this.getExplorations()
          })
        } else {
          return false;
        }
      },
      duplicateExploration(id) {
        let check = confirm("Would you like to create a copy of this exploration?");
        if (check == true) {
          fb.explorationsCollection.doc(id).get().then(doc => {
            let toDuplicate = doc.data()
            console.log(toDuplicate)
            fb.explorationsCollection.add(toDuplicate)
            this.explorations = []
            this.getExplorations()
          })
        } else {
          return false;
        }
      },
      getExplorations() {
        fb.explorationsCollection.where('userId', '==', this.currentUser.uid).orderBy("createdOn", "desc").get().then(querySnapshot => {
          querySnapshot.forEach(doc => {
            let exploration = doc.data()
            exploration.id = doc.id
            this.explorations.push(exploration)
          })
        })
      }
    },
    filters: {
      formatDate(val) {
        if (!val) { return '-' }
        let date = val.toDate()
        return moment(date).fromNow()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/DashboardHome.vue